export const createElement = (parent, childType, params) => {
    const child = parent.appendChild(document.createElement(childType));
    if (params) {
        Object.assign(child, params);
    }
    return child;
};
